
window.getCurrentUser = () => JSON.parse(sessionStorage.getItem('rd_user') ?? 'null');

function _authHeaders() {
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionStorage.getItem('rd_access_token') ?? ''}`,
    };
}

async function _post(path, body) {
    const res = await fetch(`${window.RD_API}${path}`, {
        method: 'POST',
        credentials: 'include',
        headers: _authHeaders(),
        body: JSON.stringify(body),
    });
    if (!res.ok) throw Object.assign(new Error(await res.text()), { status: res.status });
    return res.json();
}

async function _get(path, params = {}) {
    const qs = new URLSearchParams(params).toString();
    const res = await fetch(`${window.RD_API}${path}${qs ? '?' + qs : ''}`, {
        credentials: 'include',
        headers: _authHeaders(),
    });
    if (!res.ok) throw Object.assign(new Error(await res.text()), { status: res.status });
    return res.json();
}

async function _del(path, params = {}) {
    const qs = new URLSearchParams(params).toString();
    const res = await fetch(`${window.RD_API}${path}${qs ? '?' + qs : ''}`, {
        method: 'DELETE',
        credentials: 'include',
        headers: _authHeaders(),
    });
    if (!res.ok) throw Object.assign(new Error(await res.text()), { status: res.status });
    return res.json();
}

// ── Projects ──────────────────────────────────────────────────────────────────

window.getProjects   = () => _get('/projects/projects');
window.createProject = (name) => _post('/projects/create', { name });
window.updateProject = (projectId, projectName, description = null) =>
    _post('/projects/update', { projectId, projectName, description });
window.deleteProject = (projectId) => _del(`/projects/delete/${encodeURIComponent(projectId)}`);
window.inviteMember  = (projectId, email, role) =>
    _post(`/projects/${encodeURIComponent(projectId)}/members`, { email, role });

// ── Pages ─────────────────────────────────────────────────────────────────────

window.getPage    = (projectId, pageId) => _get('/page/getpage', { projectId, pageId });
window.getPages   = (projectId) => _get(`/page/getpages/${encodeURIComponent(projectId)}`);
window.createPage = (projectId, pageName, pageType = 'Document', folderId = null) =>
    _post('/page/createpage', { projectId, pageName, pageType, folderId });
window.updatePage = (projectId, pageId, pageName, pageType = 'Document') =>
    _post('/page/updatepage', { projectId, pageId, pageName, pageType });
window.movePage   = (projectId, pageId, folderId = null) =>
    _post('/page/movepage', { projectId, pageId, folderId });
window.deletePage = (projectId, pageId) =>
    _del('/page/deletepage', { projectId, pageId });
window.getPageSnapshot = (projectId, pageId) => _get('/page/snapshot', { projectId, pageId });
window.applyPatches    = (projectId, pageId, patches) =>
    _post(`/page/patches?pageId=${encodeURIComponent(pageId)}&projectId=${encodeURIComponent(projectId)}`, patches);
window.addPageFont     = (pageId, fontId)  => _post(`/page/pages/${encodeURIComponent(pageId)}/addfont`,    fontId);
window.removePageFont  = (pageId, fontId)  => _post(`/page/pages/${encodeURIComponent(pageId)}/removefont`, fontId);
window.getPageFonts    = (pageId) => _get(`/page/fonts/${encodeURIComponent(pageId)}`);

// ── Folders ───────────────────────────────────────────────────────────────────

window.getFolders    = (projectId) => _get(`/page/folders/${encodeURIComponent(projectId)}`);
window.createFolder  = (projectId, folderName, parentFolderId = null) =>
    _post('/page/folder/create', { projectId, folderName, parentFolderId });
window.renameFolder  = (projectId, folderId, folderName) =>
    _post('/page/folder/rename', { projectId, folderId, folderName });
window.deleteFolder  = (projectId, folderId) =>
    _del('/page/folder/delete', { projectId, folderId });
window.moveFolder    = (projectId, folderId, newParentFolderId = null) =>
    _post('/page/folder/move', { projectId, folderId, newParentFolderId });

// ── Fonts ─────────────────────────────────────────────────────────────────────

window.createFont         = (name, contentUrl, category, price, isPublic) =>
    _post('/font/create', { name, contentUrl, category, price, isPublic });
window.deleteFont         = (fontId) => _del(`/font/delete/${encodeURIComponent(fontId)}`);
window.setFontVisibility  = (fontId, isPublic) => _post('/font/visibility', { fontId, isPublic });
window.rateFont           = (fontId, value)    => _post('/font/rate', { fontId, value });
window.getPublicFonts     = () => _get('/font/public');
window.getMyFonts         = () => _get('/font/mine');
window.recordFontDownload = (fontId) => _post(`/font/download/${encodeURIComponent(fontId)}`);

// ── Auth ──────────────────────────────────────────────────────────────────────

window.getMe    = () => _get('/auth/me');
window.logout   = () => _post('/auth/logout');
